import type { NotificationType } from './NotificationDropdown.types';

export const formatRelativeTime = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 30) return 'Just now';
  if (diffInSeconds < 60) return `${diffInSeconds}s ago`;

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ago`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) return `${diffInDays}d ago`;

  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const getTypeIcon = (type: NotificationType): string => {
  switch (type) {
    case 'success':
      return 'fa-solid fa-circle-check text-emerald-400';
    case 'warning':
      return 'fa-solid fa-triangle-exclamation text-amber-400';
    case 'error':
      return 'fa-solid fa-circle-xmark text-rose-400';
    case 'info':
    default:
      return 'fa-solid fa-circle-info text-sky-400';
  }
};

export const getTypeBadgeClass = (type: NotificationType): string => {
  switch (type) {
    case 'success':
      return 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20';
    case 'warning':
      return 'bg-amber-500/10 text-amber-400 border-amber-500/20';
    case 'error':
      return 'bg-rose-500/10 text-rose-400 border-rose-500/20';
    case 'info':
    default:
      return 'bg-sky-500/10 text-sky-400 border-sky-500/20';
  }
};
